import { controls, currencyToNumber, grouped } from "../../controls";


const branches_subdaybook= {
  label: "branches_subdaybook",
  starting: true,
  url: "branches_subdaybook",
  pageLabel: "branches subdaybook",
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Branch" }),
    ...controls.oc({ tab: "filter", c: "Branch", placeHolder: "Branch Code", name: "branch_code", fastpath: "branches" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "branch_display" }),
    
    ...controls.magicDateLabel({ label: "Date", target: "as_on_date" }),
    ...controls.magicDate({ dateType: "ontype", isRequired: true, name: "as_on_date", width: "col-sm-2" }),
    ...controls.magicDateLabel({ label: "", width: "col-sm-2" }),

    ...controls.displayText({ tab: "general", label: "Gl", star: false }),
    ...controls.oc({ tab: "general", c: "GL", placeHolder: "Gl Code", name: "gl_code", isRequired: false, fastpath: "gls" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "gl_display" }),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "branches subdaybook",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },

    filterable:true,
    sortable: true,
    defaultsTo: 0,
    textReportProps: {
      '132': {
        filename: `branches subdaybook-$pageData.as_on_date$.oro`,
        empty:true,//true
        format: {},
        header: "default",
        footer: "default"
      }
    },
    reportProps: { searchable: true, sortable: true },
      extraRows: {
      location: "top",
      fields: ["credit","debit","all_total"],
      grandtotal: { type: "fixed", displayIn: "gl_display", val: "Grand Total", count: true },
      },
     displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }//3
      },
      {
        Header: "Account Number",
        accessor: "account_code",
      },
        {
        Header: "Customer Name",
        accessor: "customer_display",
        
        
      },
      {
        Header: "Total Credit",
        accessor: "credit",
        type: "currency"
        
      },
      {
        Header: "Total Debit",
        accessor: "debit",
         type: "currency",

    
      },

         {
            Header: "Total Balance",
            accessor: "all_total",
            width132: { size: 13, },
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'credit' }, { source: 'row', field: 'debit' }
              ], resultVar: 'total'
            }],
            type: "currency",
          },
  

    ]
  }
};

export default branches_subdaybook;